import { __assign } from "tslib";
import { RemoveScroll } from 'react-remove-scroll/UI';
export { AutoFocusInside, MoveFocusInside, InFocusGuard } from 'react-focus-lock/UI';
export var classNames = __assign({}, RemoveScroll.classNames);



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es2015/reExports.js
// module id = 1464
// module chunks = 2